import {
  Button,
  Combobox,
  CrossIcon,
  Dialog,
  FormField,
  Heading,
  Icon,
  IconButton,
  Pane,
  ShopIcon,
  TextInputField,
} from 'evergreen-ui';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { useForm } from 'react-hook-form';
import { mutate } from 'swr';
import { postCompany } from '../../services/api/companiesService';
import { useQueryVitaUserByIdentityId } from '../../services/api/vitaUserService';
import LoadingOverlay from '../../shared/LoadingOverlay';
import { toastNotification } from '../../shared/toastNotification';
import { backendUrl } from '../../config/config';
import { Backdrop, CircularProgress } from '@mui/material';

function CreateCompanyForm({ isShown, setIsShown }) {
  const userId = localStorage.getItem('userId');

  const [loadingBackdrop, setLoadingBackdrop] = useState(false);

  const {
    data: vitaUser,
    isLoading: isLoadingVitaUser,
  } = useQueryVitaUserByIdentityId(userId && userId, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const { register, handleSubmit, setValue, reset } = useForm({});

  const onClose = () => {
    reset();
    setIsShown(false);
  };

  const buildFormHeader = () => {
    return (
      <Pane display='flex' flex={1} justifyContent='space-between'>
        <Pane
          display='flex'
          flexDirection='row'
          flexWrap='nowrap'
          alignItems='center'
          gap={16}
        >
          <Icon icon={ShopIcon} color='selected' />
          <Heading size={700}>Nova empresa</Heading>
        </Pane>
        <IconButton appearance='minimal' icon={CrossIcon} onClick={onClose} />
      </Pane>
    );
  };

  const buildFormFooter = () => {
    return (
      <Pane display='flex' flex={1} justifyContent='flex-end'>
        <Button
          form='company-form'
          type='submit'
          appearance='primary'
          marginY={8}
        >
          Salvar
        </Button>
      </Pane>
    );
  };

  const onSubmit = (company) => {
    let statusResponse = false;
    let toastContent = '';

    let companyToCreate = {
      // cpfCnpj: company.cpfCnpj,
      fieldActivity: company.fieldActivity,
      name: company.name,
      userId: !isLoadingVitaUser && vitaUser.data.id,
    };

    console.log('submit company: ', companyToCreate);
    setLoadingBackdrop(true);

    postCompany(companyToCreate)
      .then((res) => {
        console.log('res post user: ', res);
        statusResponse = 'success';
        toastContent = 'Empresa criada com sucesso.';
        const newCompanyId = res.data.id;
        localStorage.setItem('companyId', newCompanyId);

        // Atualiza lista de empresas e fecha dialog imediatamente
        mutate('vitaUserByIdentityId');
        onClose();

        // Preset roda em background — invalida caches de /categorias ao terminar
        fetch(`${backendUrl}/Companies/preset`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          },
          body: JSON.stringify({
            companyId: newCompanyId,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log('data preset: ', data);
          })
          .catch((err) => {
            console.log('err preset: ', err);
          })
          .finally(() => {
            mutate(`accountPlans-${newCompanyId}`);
            mutate(`dreGrouping-${newCompanyId}`);
          });
      })
      .catch((err) => {
        statusResponse = 'warning';
        console.log('post err', err);
        toastContent = `Verifique os campos novamente.`;
      })
      .finally(() => {
        toastNotification(statusResponse, toastContent);
        setLoadingBackdrop(false);
      });
  };

  if (isLoadingVitaUser) {
    return <LoadingOverlay />;
  }

  return (
    <Dialog
      isShown={isShown}
      title=''
      onCloseComplete={onClose}
      confirmLabel='Custom Label'
      hasFooter={true}
      header={buildFormHeader}
      footer={buildFormFooter}
      width={800}
      backgroundColor='#f8f8f8'
    >
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loadingBackdrop}
      >
        <div className='flex flex-col items-center justify-center gap-4 text-xl text-center'>
          <h1 className='font-bold'>
            Finalizando a criação da sua empresa, aguarde...
          </h1>
          <CircularProgress color='inherit' />
        </div>
      </Backdrop>
      <form id='company-form' onSubmit={handleSubmit(onSubmit)}>
        <FormField>
          <Container
            fluid={true}
            style={{
              width: '100%',
              margin: 0,
              padding: 0,
            }}
          >
            <Row>
              <Col sm={12} md={12} lg={12}>
                <TextInputField
                  padding={0}
                  {...register('name')}
                  label='Nome'
                  id='name'
                  name='name'
                  type='text'
                />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <TextInputField
                  {...register('cpfCnpj', {
                    required: true,
                  })}
                  label='CPF ou CNPJ'
                  id='cpfCnpj'
                  name='cpfCnpj'
                  placeholder=''
                />
              </Col>
            </Row> */}

            <Row>
              <Col sm={12} md={12} lg={12}>
                <Heading size={400} marginBottom={8}>
                  Área de atuação
                </Heading>
                <Combobox
                  label='Área de atuação'
                  {...register('fieldActivity')}
                  initialSelectedItem={''}
                  items={[
                    {
                      id: 1,
                      name: '',
                    },
                    {
                      id: 2,
                      name: 'Comércio',
                    },
                    { id: 3, name: 'Indústria' },
                    {
                      id: 4,
                      name: 'Serviços',
                    },
                  ]}
                  itemToString={(item) => {
                    return item?.name ?? '';
                  }}
                  onChange={(selected) => {
                    console.log('tipo empresa: selected: ', selected);
                    setValue('fieldActivity', selected.name);
                  }}
                  marginBottom={24}
                  width='100%'
                />
              </Col>
            </Row>
          </Container>
        </FormField>
      </form>
    </Dialog>
  );
}

export default CreateCompanyForm;
